// =============================================================================
// LOG DETAILS FORMATTER
// =============================================================================
// Converts a log entry's `details` object into human-friendly label/value rows
// for display in the admin log viewers (instead of raw JSON).
// =============================================================================

/**
 * Humanize a details key: snake_case/camelCase → "Title Case".
 * e.g. "block_user" → "Block User", "isUpdate" → "Is Update"
 */
function humanizeKey(key) {
  return String(key)
    .replace(/[_-]+/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/**
 * Format a details value for display.
 */
function formatValue(value) {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (Array.isArray(value)) {
    return value.length ? value.map(formatValue).join(', ') : '—';
  }
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

/**
 * Convert a details object into an array of { label, value } rows.
 * Returns an empty array for non-object / empty input.
 */
export function formatLogDetails(details) {
  if (!details || typeof details !== 'object' || Array.isArray(details)) {
    return [];
  }
  return Object.entries(details).map(([key, value]) => ({
    label: humanizeKey(key),
    value: formatValue(value),
  }));
}
